import EthIcon from '@/assets/icons/ethereum.svg';
import BscIcon from '@/assets/icons/bsc.svg';
import PolygonIcon from '@/assets/icons/polygon.svg';

export const networkLabelMap: Record<string, string> = {
  POLYGON: 'Polygon',
  BSC: 'BNB Smart Chain',
  ETHEREUM: 'Ethereum',
  BINANCE: 'BNB Smart Chain',
};

export const networkIconMap: Record<string, string> = {
  POLYGON: PolygonIcon,
  BSC: BscIcon,
  ETHEREUM: EthIcon,
  BINANCE: BscIcon,
};

export const networkConfirmationsMap: Record<string, number> = {
  POLYGON: 100,
  BSC: 18,
  BINANCE: 18,
};

export const networks = [
  { value: 'POLYGON', label: 'Polygon', icon: PolygonIcon },
  { value: 'BSC', label: 'BNB Smart Chain', icon: BscIcon },
  // { value: 'ETHEREUM', label: 'Ethereum', icon: EthIcon },
  // { value: 'BINANCE', label: 'BNB Smart Chain', icon: BscIcon },
];

export function getNetworkLabel(network: string) {
  return networkLabelMap[network] ?? network;
}

export function getNetworkIcon(network: string) {
  return networkIconMap[network];
}

export function getNetworkConfirmations(network: string) {
  return networkConfirmationsMap[network];
}
